import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useCancellationOverlay } from "@/components/cancellation-overlay-context";
import { fetchSiteContent } from "@/lib/services/site-content.service";

type FooterContent = {
  copyright?: string;
};

export function Footer() {
  const [content, setContent] = useState<FooterContent>({ copyright: "© 2026 SEPPS Fitness GmbH" });
  const { openCancellation } = useCancellationOverlay();

  useEffect(() => {
    fetchSiteContent('footer').then(d => { if (d?.content) setContent(d.content); }).catch(() => {});
  }, []);

  return (
    <footer className="relative z-10 font-kanit pt-6 md:pt-8" style={{ backgroundColor: "var(--footer-bg)", color: "var(--footer-text)" }}>
      {/* ── Social / Mobile Instagram ── */}
      <div className="w-full flex justify-center mb-6 md:hidden">
        <a
          href="https://www.instagram.com/sepps.fitness/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 opacity-50 hover:opacity-100 transition-opacity"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="w-4 h-4"
          >
            <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
            <circle cx="12" cy="12" r="4" />
            <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none" />
          </svg>
          <span className="text-xs uppercase tracking-widest font-medium">@sepps.fitness</span>
        </a>
      </div>

      {/* ── Copyright | Logo | Legal ── */}
      <div className="w-full page-content pb-8 md:pb-12 md:py-8">
        <div className="flex flex-col items-center gap-4 md:grid md:grid-cols-3 md:items-center">
          <p className="text-sm opacity-35 md:justify-self-start">{content.copyright}</p>

          {/* Logo – nur Desktop */}
          <div className="hidden md:flex md:justify-self-center">
            <img src="/logo.webp" alt="SEPP'S Fitness" loading="lazy" decoding="async" className="h-8 w-auto" />
          </div>

          <nav className="flex flex-wrap justify-center items-center gap-4 text-sm md:justify-self-end md:gap-5">
            <Link to="/kontakt" className="opacity-35 hover:opacity-100 transition-opacity duration-200">Kontakt</Link>
            <Link to="/legal/impressum" className="opacity-35 hover:opacity-100 transition-opacity duration-200">Impressum</Link>
            <Link to="/legal/datenschutz" className="opacity-35 hover:opacity-100 transition-opacity duration-200">Datenschutz</Link>
            <Link to="/legal/agb" className="opacity-35 hover:opacity-100 transition-opacity duration-200">AGB</Link>
            <Link to="/legal/widerruf" className="opacity-35 hover:opacity-100 transition-opacity duration-200">Widerruf</Link>
            <button
              type="button"
              onClick={openCancellation}
              className="opacity-35 hover:opacity-100 transition-opacity duration-200 text-left"
            >
              Abo kündigen
            </button>
          </nav>
        </div>
      </div>
    </footer>
  );
}
